const internet = {
  classAdd: {
    name: "设备分类新增",
    type: "post",
    path: "/device/class/add",
  },
};
export default internet;
